import React          from 'react';

export const IdentNumber = ({ value, record }) => ( (record.careProvider) ?
    <React.Fragment>
      { record.careProvider.identNumber }
      {(record.careProvider.destinationKey) ? <React.Fragment><br />{ `(${record.careProvider.destinationKey})` }</React.Fragment> : '' }
    </React.Fragment> :
    <i>---</i>
)
